import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import ButtonBlue from "../../components/Button/ButtonBlue";
import NewTask from "./NewTask";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { useDispatch, useSelector } from "react-redux";
import { getTeachingCourses } from "../../redux/actions/teachingCourses";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import Swal from "sweetalert2";
import { Select, MenuItem } from "@mui/material";
import { toast } from "react-toastify";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  convertHtmlToDraft,
  tokenAuthorize,
} from "../../components/Helpers/Common";
import DPEditor from "../../components/Editor/DPEditor";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Button from "../../components/Button/Button";
import ButtonCommon from "../../components/Button/ButtonCommon";
import {
  ButtonCommonTopNew,
  SideBarActiveDiv,
  SideBarActiveDivButtonNew,
  SideBarNormalDivButtonNew,
} from "../Theme";
import { BiLeftArrowAlt } from "react-icons/bi";
import { Tooltip } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import Modal from "../../components/Modal/ModelNewPopup";
import TaskReorderModal from "../../components/Modal/TaskReorderModal";
import { BsArrowLeft } from "react-icons/bs";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

export default function NewTaskList(props) {
  const id = props.match.params.id;
  const dispatch = useDispatch();
  let history = useHistory();

  const [title, setTitle] = useState("");
  const [created, setCreated] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [desc, setDesc] = useState("");
  const [tasks, setTasks] = useState([]);
  const [dateIcon, setDateIcon] = useState("");
  const [currentTask, setCurrentTask] = useState(null);
  const [selectedIndex, setselectedIndex] = useState(0);
  const [isAddtask, setIsAddTask] = useState(false);
  const [taskName, setTaskName] = useState("");
  const buttonRef = useRef(null);
  const inputAddShowcaseRef = useRef(null);
  const [isReorderOpen, setIsReorderOpen] = useState(false);

  const handleDate = (e) => {
    const icon = new Date(e.target.value).getDate();
    setDateIcon(icon);
    setDueDate(e.target.value);
  };

  const handleReorder = (tasks, index) => {
    setTasks(tasks);
    setselectedIndex(index);
  };

  const refreshData = (taskId) => {
    axios
      .get(serverUrl.LearningMyTask + `/${taskId}`)
      .then((resp) => {
        if (resp.status === 200) {
          const data = resp.data;

          setTitle(data.list_name);

          const receivedTasks = data.tasks.map((cTaskData) => ({
            ...cTaskData,
            task_detail: cTaskData.detail,
            task_response: cTaskData.response_type,
          }));
          setTasks(receivedTasks);
          changeCurrentTask(receivedTasks);
          setDesc(data.list_desc);

          let dueDate = new Date(data.list_due);
          const tzoffset = dueDate.getTimezoneOffset() * 60000;
          const tzDueDate = new Date(dueDate.getTime() - tzoffset)
            .toISOString()
            .substr(0, 10);

          let created = new Date(data.list_created);
          setDateIcon(dueDate.getDate());
          setCreated(
            created.getFullYear() +
            "-" +
            (created.getMonth() + 1) +
            "-" +
            created.getDate()
          );
          setDueDate(tzDueDate);
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
      });
  };
  useEffect(() => {
    if (id) {
      refreshData(id);
    }
  }, [id]);

  const notifyError = (messages) => {
    let errorText = "";
    if (messages && messages.length > 0) {
      errorText = messages.join("<br/>");
    } else {
      errorText = "Something went wrong!";
    }

    Swal.fire({
      heightAuto: false,
      icon: "error",
      title: "Error",
      html: errorText,
    });
  };

  const handleRequest = async () => {
    tasks.map((i, ind) => (i.task_order = ind + 1));
    setTasks(tasks);
    if (id) {
      axios
        .put(serverUrl.LearningMyTask + `/${id}`, {
          list_name: title,
          list_due: dueDate,
          list_desc: desc,
          tasks,
        })
        .then((resp) => {
          if (resp.status === 200) {
            refreshData(id);

            Swal.fire({
              title: "Success",
              text: "Task list has been updated",
              icon: "success",
              showCancelButton: false,
              showDenyButton: true,
              confirmButtonText: "To My Task List",
              denyButtonText: "Continue Editing",
              confirmButtonColor: "#3085d6",
              denyButtonColor: "#c1c1c1",
            }).then((result) => {
              if (result.isConfirmed) {
                history.push("/tasks/mytask");
              } else if (result.isDenied) {
                Swal.close();
              }
            });
          } else {
            notifyError();
          }
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
          notifyError(error.response.data);
        });
    } else {
      if (tasks.length > 0) {
        if (
          tasks.filter(
            (task) => task.task_name.length === 0 && task.is_deleted != true
          ).length !== 0
        ) {
          Swal.fire({
            title: "Cannot save task list",
            text: "Please fill all task name",
            icon: "warning",
            confirmButtonColor: "#3085d6",
          });
        } else {
          var thisIsObject = {};
          let data = [];
          let filterdata = tasks.filter((i) => i.is_deleted == false);
          filterdata.map(
            (i) => (
              (thisIsObject = i),
              delete thisIsObject["is_deleted"],
              (i = thisIsObject),
              data.push(thisIsObject),
              (thisIsObject = {})
            )
          );

          axios
            .post(serverUrl.LearningMyTask, {
              list_name: title,
              list_due: dueDate,
              list_desc: desc,
              tasks: data,
            })
            .then((resp) => {
              if (resp.status === 200) {
                Swal.fire({
                  title: "Success",
                  text: "Task list has been created",
                  icon: "success",
                  showCancelButton: false,
                  showDenyButton: true,
                  confirmButtonText: "To My Task List",
                  denyButtonText: "Continue Editing",
                  confirmButtonColor: "#3085d6",
                  denyButtonColor: "#c1c1c1",
                }).then((result) => {
                  if (result.isConfirmed) {
                    history.push("/tasks/mytask");
                  } else if (result.isDenied) {
                    history.push("/tasks/edit/" + resp.data.id);
                  }
                });
              } else {
                notifyError();
              }
            })
            .catch((error) => {
              tokenAuthorize(error?.response?.status);
              notifyError(error.response.data);
            });
        }
      } else {
        Swal.fire({
          title: "Cannot save task list",
          text: "Please add a task first",
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
      }
    }
  };

  const handleAddTask = () => {
    setTasks([
      ...tasks,
      {
        task_name: "",
        task_detail: "",
        task_response: 0,
        is_deleted: false,
        task_order: tasks?.length > 0 ? tasks.length + 1 : 0,
      },
    ]);
  };

  const setTaskData = (itemIndex, inputType, updatedData) => {
    setTasks((prevState) => {
      let updatedTasks = [...prevState];

      switch (inputType) {
        case 0:
          updatedTasks[itemIndex].task_detail = updatedData;
          break;
        case 1:
          updatedTasks[itemIndex].task_name = updatedData;
          break;
        case 2:
          updatedTasks[itemIndex].task_response = updatedData;
          break;
        case 3:
          updatedTasks[itemIndex].is_deleted = true;
          changeCurrentTask(updatedTasks);
          break;
        case 4:
          if (updatedData == "up" && itemIndex == 0) {
            var temp = updatedTasks[itemIndex];
            updatedTasks[itemIndex] = updatedTasks[updatedTasks?.length - 1];
            updatedTasks[updatedTasks?.length - 1] = temp;
          }
          if (updatedData == "down" && itemIndex == updatedTasks?.length - 1) {
            var temp = updatedTasks[0];
            updatedTasks[0] = updatedTasks[updatedTasks?.length - 1];
            updatedTasks[updatedTasks?.length - 1] = temp;
          }
          if (updatedData == "up" && itemIndex > 0) {
            var temp = updatedTasks[itemIndex];
            updatedTasks[itemIndex] = updatedTasks[itemIndex - 1];
            updatedTasks[itemIndex - 1] = temp;
          }
          if (
            updatedData == "down" &&
            itemIndex >= 0 &&
            itemIndex != updatedTasks?.length - 1
          ) {
            var temp = updatedTasks[itemIndex];
            updatedTasks[itemIndex] = updatedTasks[itemIndex + 1];
            updatedTasks[itemIndex + 1] = temp;
          }
          updatedTasks?.map((i, ind) => (i.task_order = ind + 1));
          break;
        default:
          break;
      }
      if (inputType !== 3) {
        setCurrentTask(updatedTasks[itemIndex]);
      }
      return updatedTasks;
    });
  };

  const handleDragEnd = (param) => {
    const srcIdx = param.source.index;
    const desIdx = param.destination?.index;
    // if (desIdx) {
    tasks.splice(desIdx, 0, tasks.splice(srcIdx, 1)[0]);
    // }
    tasks.map((i, ind) => (i.task_order = ind + 1));
    setTasks(tasks);
  };

  const handleCancel = () => {
    Swal.fire({
      heightAuto: false,
      title: "Warning",
      text: "Are you sure want to Cancel?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        history.push("/tasks/mytask");
      }
    });
  };

  const handleInputAddShowcaseBlur = (e) => {
    if (e?.nativeEvent?.relatedTarget?.id === buttonRef?.current?.id) {
      handleAddTaskFocus();
      return;
    }
    setIsAddTask(false);
  };

  useEffect(() => {
    handleAddTaskFocus();
  }, [isAddtask]);

  const handleAddTaskFocus = () => {
    if (isAddtask && inputAddShowcaseRef.current) {
      inputAddShowcaseRef.current.focus(); // focus after entering edit mode
    }
  };

  const handleCreateTask = () => {
    if (taskName?.trim() == "" || !taskName?.trim()) {
      handleAddTaskFocus();
      toast.error("Please enter the task name");
    } else {
      handleNewTask(taskName);
      setTaskName("");
      setIsAddTask(false);
    }
  };

  const handleNewTask = (taskname) => {
    let taskList = tasks;
    taskList = [
      ...taskList,
      {
        task_name: taskName,
        task_detail: "",
        task_response: 0,
        is_deleted: false,
        task_order: tasks?.length > 0 ? tasks.length + 1 : 0,
      },
    ];
    if (!currentTask) {
      changeCurrentTask(taskList);
    }
    setTasks([
      ...tasks,
      {
        task_name: taskName,
        task_detail: "",
        task_response: 0,
        is_deleted: false,
        task_order: tasks?.length > 0 ? tasks.length + 1 : 0,
      },
    ]);
  };

  const changeCurrentTask = (taskList) => {
    if (taskList.filter((data) => data.is_deleted == false).length == 0) {
      setCurrentTask(null);
    } else {
      const firstActiveTask = taskList.find(
        (task) => task?.is_deleted === false
      );
      setCurrentTask(firstActiveTask !== undefined ? firstActiveTask : null);
    }

    if (taskList.length == 0) {
      setselectedIndex(-1);
    } else {
      const firstActiveIndex = taskList.findIndex(
        (task) => task?.is_deleted === false
      );
      setselectedIndex(firstActiveIndex);
    }
  };

  return (
    <div>
      <Modal
        isOpen={isReorderOpen}
        onClose={() => setIsReorderOpen(false)}
        header="Reorder Task"
      >
        <TaskReorderModal
          tasks={tasks}
          onSave={handleReorder}
          selectedIndex={selectedIndex}
          onClose={() => {
            setIsReorderOpen(false);
          }}
        />
      </Modal>
      <div className="flex flex-col pt-2 md:pt-6">
        <div className="px-3 md:px-5">
          <div className="flex mt-2 text-sm mb-4 justify-between items-center">
            {/* <ButtonCommonTopNew
              className={`rounded-lg px-5 py-2 flex items-center w-max cursor-pointer`}
              onClick={handleCancel}
            >
              <BiLeftArrowAlt className="w-5 h-5" />
              <h1 className="text-xs lg:text-sm">Back</h1>
            </ButtonCommonTopNew> */}
            <div
              className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
              onClick={handleCancel}
            >
              <KeyboardBackspaceIcon
                style={{ fontSize: "28px" }}
                className=" primaryIcon"
              />
              <h1 className="text-lg blueColor font-semibold">Back</h1>
            </div>
            <ButtonCommon
              title="Save"
              className=" px-6 py-2"
              onClick={handleRequest}
            />
          </div>
          <div className="flex items-center gap-3 flex-wrap w-full">
            <div className="flex items-center gap-3">
              <span className="text-black font-semibold text-sm">Name: </span>
              <input
                type="text"
                className="px-2 py-1.5 border rounded border-gray-300 text-sm w-44"
                placeholder="My task list name"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="flex items-center gap-3">
              {/* <div className="w-8 lg:w-10 flex flex-wrap content-center justify-center calendar">
                  <p className="text-blue-500 font-semibold pt-2">{dateIcon}</p>
                </div> */}
              <span className="text-black font-semibold text-sm">Due on: </span>
              <input
                type="date"
                className="px-2 py-1 border border-gray-300 rounded w-44"
                value={dueDate}
                onChange={(date) => handleDate(date)}
              />
            </div>
          </div>

          <p className="font-bold mt-4 mb-4">Description: </p>
          <div className="grid mb-5">
            <DPEditor content={desc} setContent={setDesc} height={300} />
          </div>
        </div>
        {/* <div className="flex justify-end my-6">
          <ButtonCommonTopNew
            className="px-4 py-2 text-sm rounded-lg cursor-pointer"
            onClick={handleAddTask}
          >
            + Add More Task
          </ButtonCommonTopNew>
        </div> */}
        <div className=" lg:pl-5 flex w-full h-full border-top-f1 flex-col lg:flex-row">
          <div className="w-72 border-right-f1 pr-5 py-4 hidden lg:block">
            <SideBarActiveDiv className="text-xl font-bold blackColor flex items-center justify-between gap-5  py-1">
              {isAddtask ? (
                <>
                  <input
                    className="bg-white border rounded-md text-black bg-transparent text-sm placeholder-gray-500 focus:outline-none pl-3 h-9 w-full border-gray-500"
                    type="text"
                    ref={inputAddShowcaseRef}
                    autoFocus
                    placeholder="Add task"
                    value={taskName}
                    onChange={(e) => setTaskName(e.target.value)}
                    onBlurCapture={(e) => handleInputAddShowcaseBlur(e)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleCreateTask();
                      }
                    }}
                  />
                </>
              ) : (
                <>Tasks</>
              )}
              {!isAddtask ? (
                <div className="flex items-center gap-3">
                  {tasks.filter((data) => data.is_deleted == false).length >
                    1 && (
                      <Tooltip title={"Reorder task"} placement="top" arrow>
                        <ButtonCommonTopNew
                          className="flex items-center border w-8 h-8 justify-center rounded-lg cursor-pointer"
                          onClick={() => {
                            setIsReorderOpen(true);
                          }}
                        >
                          <SwapVertIcon
                            style={{ fontSize: "22px" }}
                            className="cursor-pointer"
                          />
                        </ButtonCommonTopNew>
                      </Tooltip>
                    )}
                  <Tooltip title={"New task"} placement="top" arrow>
                    <ButtonCommonTopNew
                      className="flex items-center border w-8 h-8 justify-center rounded-lg cursor-pointer"
                      onClick={() => {
                        setIsAddTask(true);
                        setTaskName("");
                      }}
                    >
                      <AddOutlinedIcon className="cursor-pointer primaryIcon" />
                    </ButtonCommonTopNew>
                  </Tooltip>
                </div>
              ) : (
                <Tooltip title={"Add task"} placement="top" arrow>
                  <ButtonCommonTopNew
                    className="flex items-center border p-1 rounded-lg cursor-pointer"
                    ref={buttonRef}
                    id="blur"
                    tabIndex={0}
                    onClick={() => {
                      handleCreateTask();
                    }}
                  >
                    <DoneOutlinedIcon className="cursor-pointer primaryIcon" />
                  </ButtonCommonTopNew>
                </Tooltip>
              )}
            </SideBarActiveDiv>
            <div className="flex flex-col flex-1 mt-1 ">
              {tasks.map((list, index) => {
                if (list?.is_deleted) return null; // skip deleted but keep index reference

                return selectedIndex === index ? (
                  <SideBarActiveDivButtonNew
                    key={index}
                    type="button"
                    className="text-md flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium"
                    onClick={() => {
                      setCurrentTask(list);
                      setselectedIndex(index);
                    }}
                  >
                    {list.task_name}
                  </SideBarActiveDivButtonNew>
                ) : (
                  <SideBarNormalDivButtonNew
                    key={index}
                    type="button"
                    className="text-md flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium"
                    onClick={() => {
                      setCurrentTask(list);
                      setselectedIndex(index);
                    }}
                  >
                    {list.task_name}
                  </SideBarNormalDivButtonNew>
                );
              })}
            </div>
          </div>
          <div className=" py-5 ml-1 px-5 cardBackgroundColor flex items-center justify-between lg:hidden gap-2">
            <div className="flex items-center gap-2">
              {isAddtask ? (
                <input
                  className="bg-white border rounded-md text-black bg-transparent text-sm placeholder-gray-500 focus:outline-none pl-3 h-9 w-full border-gray-500"
                  type="text"
                  ref={inputAddShowcaseRef}
                  autoFocus
                  placeholder="Add task"
                  value={taskName}
                  onChange={(e) => setTaskName(e.target.value)}
                  onBlurCapture={(e) => handleInputAddShowcaseBlur(e)}
                />
              ) : (
                <>
                  <span className="text-sm blackColor">Tasks:</span>
                  <Select
                    labelId="task-select-label"
                    className="w-44"
                    style={{ height: "35px" }}
                    value={selectedIndex}
                    onChange={(e) => {
                      const selected = tasks.find(
                        (t, index) => index === e.target.value
                      );
                      if (selected) {
                        setCurrentTask(selected);
                        setselectedIndex(e.target.value);
                      }
                    }}
                    MenuProps={{
                      disableScrollLock: true,
                    }}
                  >
                    {tasks.map((task, index) => {
                      if (task?.is_deleted) return null;

                      return (
                        <MenuItem key={index} value={index}>
                          {task.task_name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </>
              )}
            </div>
            {!isAddtask ? (
              <div className="flex items-center gap-3">
                {tasks.filter((data) => data.is_deleted == false).length >
                  1 && (
                    <Tooltip title={"Reorder task"} placement="top" arrow>
                      <ButtonCommonTopNew
                        className="flex items-center border w-8 h-8 justify-center rounded-lg cursor-pointer"
                        onClick={() => {
                          setIsReorderOpen(true);
                        }}
                      >
                        <SwapVertIcon
                          style={{ fontSize: "22px" }}
                          className="cursor-pointer"
                        />
                      </ButtonCommonTopNew>
                    </Tooltip>
                  )}
                <Tooltip title={"New task"} placement="top" arrow>
                  <ButtonCommonTopNew
                    className="flex items-center border w-8 h-8 justify-center rounded-lg cursor-pointer"
                    onClick={() => {
                      setIsAddTask(true);
                      setTaskName("");
                    }}
                  >
                    <AddOutlinedIcon className="cursor-pointer primaryIcon" />
                  </ButtonCommonTopNew>
                </Tooltip>
              </div>
            ) : (
              <Tooltip title={"Add task"} placement="top" arrow>
                <ButtonCommonTopNew
                  className="flex items-center border p-1 rounded-lg cursor-pointer"
                  ref={buttonRef}
                  id="blur"
                  tabIndex={0}
                  onClick={() => {
                    handleCreateTask();
                  }}
                >
                  <DoneOutlinedIcon className="cursor-pointer primaryIcon" />
                </ButtonCommonTopNew>
              </Tooltip>
            )}
          </div>
          <div className="flex-1 backGroundColor p-5 border20pxbottomright">
            {currentTask && (
              <NewTask
                key={selectedIndex}
                item={currentTask}
                index={selectedIndex}
                setTaskData={setTaskData}
              />
            )}
            {!currentTask && (
              <span className="flex h-full items-center justify-center w-full text-md font-semibold blackColor">
                Please create a task
              </span>
            )}
          </div>
        </div>
        {/* <div className="">
          {tasks &&
            tasks.map(
              (task, idx) =>
                task?.is_deleted == false && (
                  <NewTask
                    key={idx}
                    item={task}
                    index={idx}
                    setTaskData={setTaskData}
                  />
                )
            )}
        </div> */}
      </div>
    </div>
  );
}
